module.exports = __webpack_public_path__ + "static/04-21d06c5d186485c6e486f7745faeb5b9.jpg";